export enum Experience {
  Default = 0,
  EmeraldCommercial = 2,
  EmeraldConsumer = 4,
  Error = 100,
  Offline = 101,
  GeoBlocked = 102,
}

export type ServiceConfig = {
  ContextServiceEndpoint: string;
  ContextServiceTimeoutInMilliseconds: number;
  NotifyAppClosingTimeoutInMilliseconds: number;
  SessionTimeoutInMilliseconds: number;
  ViewerConnectTimeoutInMilliseconds: number;
  ViewerDisconnectTimeoutInMilliseconds: number;
  LaunchWebLinksInEdge: boolean;
};

export type ContextDataResponse = {
  LandingPageRelativePath: string;
  Invoker: string;
  InvokerPath: string;
  SearchKey: string;
  IssueType: string;
  Product: string;
  RequiresSignIn: boolean;
  SiteName: string;
  SitePolicy: string;
  SessionId: string;
  FlightingOverride: string;
  EffectiveCapabilities: string[];
  ServiceConfig: ServiceConfig;
};

export type DetectedApp = {
  DisplayName: string;
  Version: string;
  IsMwaasManaged: boolean;
  SizeInByte: number;
  DeviceCount: number;
};

export type SystemInfo = {
  OS: string;
  MajorOSVersion: number;
  OsVersionString?: string;
  AppVersionString?: string;
};

export enum FlightingDecision {
  ControlGroup,
  NotSelectedForFlighting,
  SelectedForFlighting,
}

export type GetHelpExperienceResponse = {
  Experience?: Experience;
  LandingPagePath?: string;
  ContextResponse?: ContextDataResponse;
  EmeraldQueries?: { [key: string]: string };
  FeatureFlightSelectedList?: { [key: string]: FlightingDecision };
  SystemInfo: SystemInfo;
  DeviceId: string;
  Overrides: { [key: string]: string };
};

export type ExperienceMetaData = {
  FeatureFlightSelectedList?: string[];
  SystemInfo: SystemInfo;
  DeviceId: string;
  Overrides: { [key: string]: string };
  Manufacturer: string;
  ManufacturerLink: string;
};
